var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWork = function SvgWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 51c-1 0-1.875-.379-2.625-1.137S2 48.221 2 47.211V16.895c0-1.01.375-1.895 1.125-2.653s1.625-1.137 2.625-1.137H17V6.79c0-1.01.375-1.894 1.125-2.652C18.875 3.379 19.75 3 20.75 3h12.5c1 0 1.875.379 2.625 1.137S37 5.779 37 6.789v6.316h11.25c1 0 1.875.38 2.625 1.137C51.625 15 52 15.884 52 16.895V47.21c0 1.01-.375 1.894-1.125 2.652-.75.758-1.625 1.137-2.625 1.137H5.75Zm0-3.79h42.5V16.896H5.75V47.21Zm15-34.105h12.5V6.79h-12.5v6.316Z",
    fill: "#B0003C"
  })));
};
export default SvgWork;